var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _polygon, _path3, _path4, _rect11, _path5, _path6, _path7, _rect12, _path8, _path9, _path10, _path11, _rect13, _rect14, _path12, _path13, _path14, _path15, _rect15, _path16, _rect16, _rect17, _path17, _rect18, _rect19, _rect20, _path18, _rect21, _rect22, _rect23, _path19, _rect24, _rect25, _rect26, _path20, _path21, _rect27, _rect28, _path22, _rect29, _rect30, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Belarus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7cb342",
    d: "M42.838,30.667H12V31v2v2v2v2v0.973C15.345,42.49,19.491,44,24,44 C32.704,44,40.089,38.429,42.838,30.667z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 17,
    fill: "#eceff1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 13,
    fill: "#eceff1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 15,
    fill: "#eceff1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 23,
    fill: "#eceff1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 21,
    fill: "#eceff1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 25,
    fill: "#eceff1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 27,
    fill: "#eceff1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 19,
    fill: "#eceff1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 17,
    fill: "#eceff1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 33,
    fill: "#eceff1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6,15.326C5.737,15.871,5.498,16.429,5.284,17H6V15.326z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "10,29 10,31 12,31 12,30.667 12,29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M12,11V9h-1.198C10.531,9.239,10.258,9.476,10,9.729V11H12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M5.284,31C5.498,31.571,5.737,32.129,6,32.674V31H5.284z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 31,
    fill: "#eceff1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6,27H4.249c0.102,0.679,0.238,1.345,0.407,2H6V27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6,23H4.05C4.034,23.333,4,23.662,4,24s0.034,0.667,0.05,1H6V23z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10,13v-2H8.82C8.533,11.335,8.264,11.683,8,12.036V13H10z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 21,
    fill: "#eceff1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6,19H4.656c-0.169,0.655-0.304,1.321-0.407,2H6V19z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M8,33H6.157c0.348,0.689,0.725,1.36,1.148,2H8V33z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10,35H8v0.964C8.264,36.317,8.533,36.665,8.82,37H10V35z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M8,13H7.305c-0.423,0.64-0.8,1.311-1.148,2H8V13z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 29,
    fill: "#eceff1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 25,
    fill: "#eceff1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M12,37h-2v1.271c0.258,0.253,0.531,0.49,0.802,0.729H12V37z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M8,12.036C7.763,12.354,7.524,12.669,7.305,13H8V12.036z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M10,9.729C9.587,10.134,9.197,10.56,8.82,11H10V9.729z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M12,8.027C11.588,8.337,11.188,8.66,10.802,9H12V8.027z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 11,
    fill: "#ff3d00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M8,17v-2H6.157C6.103,15.108,6.052,15.217,6,15.326V17H8z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 13,
    fill: "#ff3d00"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 15,
    fill: "#ff3d00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M6,17H5.284c-0.244,0.652-0.453,1.318-0.629,2H6V17z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 19,
    fill: "#ff3d00"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 17,
    fill: "#ff3d00"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 19,
    fill: "#ff3d00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M6,21H4.249c-0.099,0.657-0.165,1.324-0.199,2H6V21z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 23,
    fill: "#ff3d00"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 21,
    fill: "#ff3d00"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 23,
    fill: "#ff3d00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M6,25H4.05c0.034,0.676,0.099,1.343,0.199,2H6V25z"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 6,
    y: 27,
    fill: "#ff3d00"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 25,
    fill: "#ff3d00"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 27,
    fill: "#ff3d00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M6,29H4.656c0.176,0.682,0.385,1.348,0.629,2H6V29z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M8,31H6v1.674C6.052,32.783,6.103,32.892,6.157,33H8V31z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 29,
    fill: "#ff3d00"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 31,
    fill: "#ff3d00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M7.305,35C7.524,35.331,7.763,35.646,8,35.964V35H7.305z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 8,
    y: 33,
    fill: "#ff3d00"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 35,
    fill: "#ff3d00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M8.82,37c0.377,0.439,0.767,0.866,1.18,1.271V37H8.82z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M10.802,39c0.386,0.34,0.786,0.663,1.198,0.973V39H10.802z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M12,11v2v2v2v2v2v2v2v2v2v1.667h30.838C43.577,28.579,44,26.341,44,24c0-11.046-8.954-20-20-20 c-4.509,0-8.655,1.51-12,4.027V9V11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Belarus);
export default __webpack_public_path__ + "static/media/icons8-belarus.65a46bcf5b4a4a2295b2d8fb7efa160a.svg";
export { ForwardRef as ReactComponent };